/**
 * Голосовой ввод кабинета — общие правила для всех мест, где надиктовывают (замечания контроля
 * качества, комментарии ченджлога, дальше — база знаний):
 *
 * 1. Голос — это файл. Запись уходит на сервер сразу после «Стоп»; расшифровку делает фон
 *    (GigaAM), человек не ждёт текста и ничего не вставляет в поле руками.
 * 2. Текст и голос живут рядом: набранное не перетирается расшифровкой, в разбор идёт «текст +
 *    расшифровка».
 * 3. Не ушла запись — она остаётся в памяти браузера, кнопка «Отправить ещё раз».
 * 4. Предел одного запроса — 1,9 МБ (шлюз режет тело больше 2 МБ); Opus 32 кбит/с ≈ 8 минут.
 *
 * Сервер — общий модуль `voice_record` (`/api/voice`). Спеки `docs/specs/2026-10-26-voice-input-design.md`,
 * `docs/specs/2026-10-26-voice-server-design.md`.
 */
import { ApiFailure, apiFetch } from "@/lib/api";

/** Предел одного запроса: шлюз режет загрузку больше 2 МБ раньше сервиса. */
export const MAX_AUDIO = 1.9 * 1024 * 1024;

/** Запись в общем модуле голоса (`voice_record`). `status`: wait — ждёт расшифровки · work —
 * расшифровывается · done · failed. Файл — `url`. */
export type VoiceRecord = {
  id: number;
  status: "wait" | "work" | "done" | "failed";
  text: string;
  error: string;
  seconds: number;
  date: string;
  url: string;
};

/** Сырое тело записи → запись в общем модуле голоса (`POST /api/voice`), расшифровка — фоном.
 * Раздел прикладывает её к своему объекту по `id` (`voice_id` в своей ручке). */
export async function uploadVoice(blob: Blob, seconds = 0): Promise<VoiceRecord> {
  if (blob.size > MAX_AUDIO) {
    throw new Error(`Запись ${(blob.size / 1024 / 1024).toFixed(1)} МБ — больше 1,9 МБ: запишите короче`);
  }
  try {
    return await apiFetch<VoiceRecord>(`/api/voice?seconds=${Math.round(seconds)}`, {
      method: "POST",
      body: blob,
      headers: { "Content-Type": blob.type || "audio/webm" },
    });
  } catch (failure) {
    if (failure instanceof ApiFailure && failure.status === 413) {
      throw new Error("Шлюз не пропустил запись — она слишком большая; запишите короче");
    }
    throw failure;
  }
}

/** Состояние записей — опрос, пока идёт расшифровка (чужие без права раздела сервер не отдаёт). */
export const loadVoices = (ids: number[]) => apiFetch<VoiceRecord[]>(`/api/voice?ids=${ids.join(",")}`);
